import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class AccountImg extends PrimitiveValueObject<string> {
  static create(value: string): AccountImg {
    return new AccountImg(value);
  }
}
